<template>
  <div class="footer-container">
    <n-space justify="right">
      <a href="/pdfs/TermsOfService.pdf" target="_blank"><n-text type="default">Terms of Service</n-text></a>
      <n-divider vertical/>
      <a href="/pdfs/PrivacyPolicy.pdf" target="_blank"><n-text type="default">Privacy Policy</n-text></a>
    </n-space>
  </div>
</template>

<style lang="scss" scoped>
@import '@/mixins.scss';

.footer-container {
  padding: 0.75rem 1.5rem;
  display: grid;
  align-items: center;
  background-color: black;

  @include s-down {
    padding-left: .5rem;
    padding-right: .5rem;
  }

  @include xxl-up {
    width: 120rem;
  }
}
</style>